import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { getUrlPrefixFromView, useNavigate } from 'frontend/js/modules/infra/routing';
import { useApiQuery } from '../../../infra/api';
import { endpoints as campaignEndpoints, endpoints } from '../network';
import { endpoints as shopEndpoints } from '../../../shop/network';
import { getViewerIdAndKind, isShopSessionView, useSession } from '../../../infra/session';
import { useFeatureFlags } from '../../../infra/feature-flags';
import { EmptyView, EmptyViewRedesign } from './empty-view';
import { EngageCampaignList as ListView } from './list-view';
import { EngageCampaignListRedesignContainer as ListViewRedesign } from './list-view/list-view-redesign-container';
import { refetchCampaignsListQuery } from '../network/utils';
export var CampaignListContainer = function () {
    var _a;
    var session = useSession().data;
    var viewerIdAndKind = getViewerIdAndKind(session);
    var _b = useFeatureFlags(), automatedCampaigns = _b.automatedCampaigns, engageNewFilters = _b.engageNewFilters;
    var navigate = useNavigate();
    var urlPrefix = getUrlPrefixFromView(session.view);
    var navigateToAutomated = function () {
        navigate("".concat(urlPrefix, "/engagement/automated"));
    };
    var campaigns = useApiQuery({
        endpoint: campaignEndpoints.campaignsQuery,
        payload: {
            ownerType: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.kind,
            ownerId: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.id,
            perPage: 1,
            page: 1,
            engageNewFilters: engageNewFilters,
        },
        options: {
            enabled: !!viewerIdAndKind,
            keepPreviousData: true,
        },
    });
    useEffect(function () {
        var shouldRefetch = campaigns.isFetched && !campaigns.isFetchedAfterMount && !campaigns.isFetching;
        // refetching is happening in background and ensures that the data is up to date
        if (shouldRefetch) {
            refetchCampaignsListQuery();
        }
        if (isShopSessionView(session === null || session === void 0 ? void 0 : session.view)) {
            shopEndpoints.barbersByShopQuery.prefetch({
                shopId: session === null || session === void 0 ? void 0 : session.view.viewer.id,
            });
            endpoints.campaignCreatorsFilterQuery.prefetch({
                shopId: session === null || session === void 0 ? void 0 : session.view.viewer.id,
            });
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    if (campaigns.isFetched && ((_a = campaigns.data) === null || _a === void 0 ? void 0 : _a.list.length) === 0) {
        return automatedCampaigns ? _jsx(EmptyViewRedesign, { onCreateAutomated: navigateToAutomated }) : _jsx(EmptyView, {});
    }
    // Switch at the top-level between classic and redesign containers
    return automatedCampaigns ? _jsx(ListViewRedesign, {}) : _jsx(ListView, {});
};
